module.exports = __webpack_public_path__ + "static/media/aboutUsVideo.4a1c5009.png";